export const phoneImg = {
  src: '/new/hero/phone.png',
};

export const cards = [
  {
    id: 'stayUpdated',
    user: {
      name: 'Kari Skandinavia',
      src: '/new/hero/user.png',
      alt: 'Kari Skandinavia',
    },
    decorAvatars: [],
  },
  {
    id: 'organize',
    postedIn: '',
    user: {},
    decorAvatars: [
      { icon: 'volleyball', size: 'md' },
      { icon: 'school', size: 'md' },
      { icon: 'mapPin', size: 'md' },
      { icon: 'users', size: 'md' },
      { icon: 'plus', size: 'sm' },
    ],
  },
];
